import React, { useState, useEffect } from 'react'
import './QueryDetails.css'
import TitleNames from '../../Component/Header/TitleNames'
import { Link, useNavigate, useParams } from "react-router-dom";
import { PostAPI, GetAPI } from '../../common/Api';
import moment from 'moment';

const QueryDetails = () => {
  const navigate = useNavigate();
  const { queryrequired } = useParams()
  const [ViewqueryDetails, setViewqueryDetails] = useState([])

  const counsellor_id = JSON.parse(sessionStorage.getItem('login_details')).counsellor_id;

  const [updatelist, setUpdatelist] = useState({
    "status": "",
    "callback_scheduled": "",
    "callback_status": "",
    "sent_to_specialist_id": "",
    "endpoint": ""
  })
  useEffect(() => {
    let formData = new FormData();
    formData.append('counsellor_id', counsellor_id);
    formData.append('query_id', queryrequired);
    var apiData = {
      url: 'get_query_detail',
      data: formData
    }

    PostAPI(apiData, (res) => {
      if (res && res.status) {
        setViewqueryDetails(res?.data)
        setUpdatelist((l) => ({ ...l, ...res?.data }))
        // console.log("da", res?.data)
      }
    })
  }, [])

  // console.log("ui", updatelist)

  const status = [
    { value: "Pending", label: "Pending" },
    { value: "Sent to Consultant", label: "Sent to Consultant" },
    { value: " Requested Information", label: " Requested Information" },
    { value: "Answered", label: "Answered" },


  ]
  const callbackStatus = [

    { id: "1", value: "Pending", label: "Pending" },
    { id: "2", value: "DND", label: "DND" },
    { id: "3", value: "To Followup", label: "To Followup" },
    { id: "4", value: "Did not respond", label: "Did not respond" },
    { id: "5", value: "Resolved", label: "Resolved" },

  ]

  const EndpointSuggestion = [
    { value: "Teleconsultation", label: "Teleconsultation" },
    { value: "Learn", label: "Learn" },
    { value: "Wellness Plans", label: "Wellness Plans" },
    { value: "Diagnostics", label: "Diagnostics" },
    { value: " Period Tracker", label: " Period Tracker" },
    { value: " Journalr", label: " Journalr" },
  ]

  const [speciality, setSpeciality] = useState([])
  const data = () => {
    var apiData = 'doctor_category_list';

    GetAPI(apiData, (res) => {
      if (res && res.status) {
        setSpeciality(res?.data)
      }
    })
  }
  useEffect(() => {
    data()
  }, [])

  const updateSubmit = () => {
    let formData = new FormData();
    formData.append('counsellor_id', counsellor_id);
    formData.append('query_id', queryrequired);
    formData.append('status', updatelist.status);
    formData.append('callback_scheduled', updatelist.callback_scheduled);
    formData.append('callback_status', updatelist.callback_status);
    formData.append('sent_to_specialist_id', updatelist.sent_to_specialist_id);
    formData.append('endpoint', updatelist.endpoint)

    var apiData = {
      url: 'update_query_detail',
      data: formData
    }

    PostAPI(apiData, (res) => {
      if (res && res.status) {
        // setViewqueryDetails(res?.data)
        // console.log("da", res?.data);
        data()


      }
    })
  }
  // console.log("ghg", updatelist)
  console.log('ViewqueryDetails',ViewqueryDetails)

  return (
    <>
      <div>  <TitleNames /></div>



      <div className='MainDerails'>
        <div className='container-fluid'>
          <div className='row'>
            {/* {ViewqueryDetails((data, index) => ( */}
            <div className='col-lg-8 col-md-8 col-sm-12 Smallcol'>

              <div><p className='NamesDetailsView'>User Query View:</p></div>

              <form action="">
                <div class="form-row">
                  <div className="form-group col-lg-6 col-md-12 ">
                    <div className='QueryDetailsContent'><p className='UserNameQuery'>User Name </p>
                      <span className='Dotspace'>:</span>
                      <p className='NameQuery'>{ViewqueryDetails?.user_name}</p></div>


                  </div>
                  <div class="form-group col-lg-6 col-md-12">
                    <div className='QueryDetailsContent'><p className='UserNameQuery'>User Number </p>
                      <span className='Dotspace'>:</span>
                      <p className='NameQuery'>{ViewqueryDetails?.user_name}</p></div>



                  </div>
                </div>
                <div className="form-group">
                  <div className='QueryDetailsContent'>
                    <p className='UserNameQuery NameQuery'>Query Date & Time </p>
                    <span className='Dotspace'>:</span>
                    <p className='NameQuery'>{moment(ViewqueryDetails?.query_sent_on).format("DD MMM YYYY HH:mm A")}
                    </p>
                  </div>

                </div>
                <div className="form-row">
                  <div className="form-group col-lg-6 col-md-6">
                    <div className='QueryDetailsContent'>
                      <p className='UserNameQuery'>Category 1 </p>
                      <span className='Dotspace'>:</span>
                      <p className='NameQuery'>{ViewqueryDetails?.choice_one}</p>
                    </div>

                  </div>
                  <div className="form-group col-lg-6 col-md-6">
                    <div className='QueryDetailsContent'>
                      <p className='UserNameQuery'>Category 2 </p>
                      <span className='Dotspace'>:</span>
                      <p className='NameQuery'>{ViewqueryDetails?.choice_two}</p>
                    </div>


                  </div>
                </div>
              </form>

              <div className='ParaQuery'>
                <p className='QueryLines'>Query:</p>
                <p className='QesryParaLines'>  {ViewqueryDetails?.query}</p>
              </div>
              <div className='container'>
                <section className="msger">
                  <header className="msger-header">
                    <div className="msger-header-title">
                      <i className="fas fa-comment-alt"></i> SimpleChat
                    </div>
                    <div className="msger-header-options">
                      <span><i className="fas fa-cog"></i></span>
                    </div>
                  </header>
                  <div className='MainMsgChat'> <div className='ChatMesg'><main className="msger-chat"></main></div></div>


                  <form className="msger-inputarea">
                    <input type="text" className="msger-input" placeholder="Enter your message..."></input>
                    <button type="submit" className="msger-send-btn">Send</button>
                  </form>
                </section>
              </div>






            </div>
            {/* // ))} */}

            <div className='col-lg-4 col-md-4 col-sm-12 Smallcol'>

              <form action="">
                <div className='ButonAlview'><Link to={`/allquerydashboard/${updatelist?.user_id}`} className='ButtnLink'>
                  <button type="button" className="StatusBtun btn-lg">Other AL Details</button>
                </Link></div>
                <div className='ButonUserPrfl'><Link to={`/userprofile/${updatelist?.user_id}`} className='ButtnLink'>
                  <button type="button" className="StatusBtun btn-lg">User Profile</button>
                </Link></div>



              </form>
              <div className=''>

                <div className='card'>
                  <div className="card-body DropStatus">
                    <div><p className='DropNamesStatus'>Status</p></div>
                    {/* <div className="dropdown">
                      <button className="dropdown-toggle StatusBtun" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Click dropdown
                      </button>
                      <div className="dropdown-menu ListDrop" aria-labelledby="dropdownMenuButton">
                        <a className="dropdown-item" href="#">Pending</a>
                        <a className="dropdown-item" href="#"> Sent to Consultant</a>
                        <a className="dropdown-item" href="#"> Requested Information</a>
                        <a className="dropdown-item" href="#"> Answered </a>
                      </div>
                    </div> */}
                    <div className="dropdown">
                      <select className=' ListDrop StatusBtun' onChange={(e) => setUpdatelist((prev) =>({ ...prev, status: e.target.value }))} name={updatelist?.status}>
                        <option hidden>Select Status</option>
                        {status?.map((o) => (
                          <option className='dropdown-item' value={o.value} selected={o.value == updatelist?.status} >{o.label}</option>))}
                      </select></div>
                  </div>
                </div>

              </div>
              <div className='SpecialistContent'>
                <div className='card'>
                  <div className='RadioContent'>
                    <div className='ScheduleCall'>
                      <p className='DropNamesStatus'>Callback
                        Scheduled
                      </p>
                    </div>
                    <div className='CallYesNo'>
                      <div className="form-check ">
                        <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="0" checked={updatelist?.callback_scheduled == "0" ? true : false} onChange={(e) => setUpdatelist((l) => ({ ...l, callback_scheduled: e.target.value }))}></input>
                        <label className="form-check-label" for="exampleRadios1">
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="1" checked={updatelist?.callback_scheduled == "1" ? true : false} onChange={(e) => setUpdatelist((l) => ({ ...l, callback_scheduled: e.target.value }))}></input>
                        <label className="form-check-label" for="exampleRadios2">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className=''>

                <div className='card'>
                  <div className="card-body DropStatus">
                    <div><p className='DropNamesStatus'>Callback
                      Status

                    </p></div>
                    {/* <div className="dropdown">
                      <button className="dropdown-toggle StatusBtun" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Click dropdown
                      </button>
                      <div className="dropdown-menu ListDrop" aria-labelledby="dropdownMenuButton">
                        <a className="dropdown-item" href="#">Gynaecologist</a>
                        <a className="dropdown-item" href="#">Nutritionist</a>

                      </div>
                    </div> */}
                    <div className="dropdown "> <select className='ListDrop  StatusBtun' onChange={(e) => setUpdatelist({ ...updatelist, callback_status: e.target.value })} name={updatelist?.callback_status}>
                      <option hidden>Select Callback</option>
                      {callbackStatus?.map((back) => (
                        <option className='dropdown-item' value={back.value} selected={back.value == updatelist?.callback_status} >{back.label}</option>))}
                    </select></div>
                  </div>
                </div>

              </div>

              <div className='SpecialistContent'>

                <div className='card'>
                  <div className="card-body DropStatus">
                    <div><p className='DropNamesStatus'>Sent to Speciality

                    </p></div>
                    {/* <div className="dropdown">
                      <button className="dropdown-toggle StatusBtun" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Click dropdown
                      </button>
                      <select className="dropdown-menu ListDrop"id="cars" aria-labelledby="dropdownMenuButton">
                        <option clssName="dropdown-item" value="Pending" > Pending</option>
                        <option className="dropdown-item" value="DND" > DND</option>
                        <option className="dropdown-item" value="To Followup" > To Followup</option>
                        <option className="dropdown-item" value="Did not respond"> Did not respond</option>
                        <option className="dropdown-item" value="Resolved"> Resolved</option>
                      </select>
                      
                    </div> */}
                    <div className="dropdown"> <select className=' ListDrop StatusBtun' onChange={(e) => setUpdatelist({ ...updatelist, sent_to_specialist_id: e.target.value })} name={updatelist?.sent_to_specialist_id}>
                      <option hidden>Select speciality</option>
                      {speciality?.map((special) => (
                        <option className='dropdown-item' value={special.id} selected={special.id == updatelist?.sent_to_specialist_id}>{special.cat_name}</option>))}
                    </select></div>

                  </div>
                </div>

              </div>

              <div className='SpecialistContent'>

                <div className='card'>
                  <div className="card-body DropStatus">
                    <div><p className='DropNamesStatus'>Endpoint Suggestion
                    </p></div>
                    {/* <div className="dropdown">
                      <button className="dropdown-toggle StatusBtun" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Click dropdown
                      </button>
                      <div className="dropdown-menu ListDrop" aria-labelledby="dropdownMenuButton">
                        <a className="dropdown-item" href="#">Teleconsultation </a>
                        <a className="dropdown-item" href="#"> Learn</a>
                        <a className="dropdown-item" href="#">  Wellness Plans</a>

                        <a className="dropdown-item" href="#"> Diagnostics </a>
                        <a className="dropdown-item" href="#">  Period Tracker </a>
                        <a className="dropdown-item" href="#">  Journal</a>
                      </div>
                    </div> */}
                    <div className="dropdown"> <select className=' ListDrop StatusBtun' onChange={(e) => setUpdatelist({ ...updatelist, endpoint: e.target.value })} name={updatelist?.endpoint}>
                      <option hidden>Select EndPoint</option>
                      {EndpointSuggestion?.map((end) => (
                        <option className='dropdown-item' value={end.value} selected={end.value == updatelist?.endpoint}>{end.label}</option>))}
                    </select></div>
                  </div>
                </div>

              </div>


              <div> <button type="submit" className="SubmitBtno" onClick={updateSubmit}>Submit</button></div>
            </div>

          </div>

        </div>
      </div>
    </>
  )
}

export default QueryDetails